import React from "react";
import OtherHero from "../../../Components/Breadcrumb/OtherHero/OtherHero";
import {
  services2,
  services3,
  services41,
  services4,
  services5,
  services6,
  services7,
  services8,
  services9,
  servicesRightHover,
  supplyBg,
} from "../../../assets/images";
import { useTranslation } from "react-i18next";

const Supply = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const newsItems = [
    {
      id: 1,
      imgSrc: services8,
      title: "Drill bits",
      path: "drillbits",
    },
    {
      id: 2,
      imgSrc: services41,
      title: "Directional drilling (Downhole Motors)",
      path: "directional",
    },
    {
      id: 3,
      imgSrc: services9,
      title: "Fiber glass tubes for cementing and coring job",
      path: "fiber",
    },
    {
      id: 4,
      imgSrc: services2,
      title: "Liner hangers",
      path: "liner",
    },
    {
      id: 5,
      imgSrc: services6,
      title: "Whipstocks",
      path: "whipstock",
    },
    {
      id: 6,
      imgSrc: services3,
      title: "Core bit",
      path: "corebit",
    },
    {
      id: 7,
      imgSrc: services4,
      title: "Pressure testing: Hydrostatic pressure testing",
      path: "hydro",
    },
    {
      id: 8,
      imgSrc: services5,
      title: "Pressure testing: Gas pressure testing",
      path: "gas",
    },
    {
      id: 9,
      imgSrc: services7,
      title: "Pressure testing: Pressure test bays",
      path: "pressure",
    },
  ];

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${supplyBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <OtherHero
          title="Supply"
          content="Efficient and reliable supply solutions for critical industries"
        />
      </div>
      <div className="bg-[#EDEDED] py-10 md:py-20 ">
        <div className="max-w-containerSm md:max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
          {newsItems.map((item) => (
            <a key={item.id} href={`/${currentLanguage}/supply/${item.path}`}>
              <div className="relative md:w-[583px] h-[372px] md:h-[440px] group overflow-hidden rounded-lg">
                {/* Image */}
                <img
                  src={item.imgSrc}
                  className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                  alt=""
                />

                {/* Title overlay with blur background */}
                <div className="absolute bottom-0 w-full flex items-center justify-between h-[72px] md:h-[84px] py-3 px-9 bg-black/50 backdrop-blur-md text-white text-[18px] md:text-[20px] font-medium">
                  <p>{t(item.title)}</p>
                  <img alt="Right Hover" className="w-6 h-6" src={servicesRightHover}></img>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default Supply;
